import {
    GET_CURRENT_PROJECT_DETAILS,
    GET_PROJECT_CODE,
    RESET_PROJECT_DETAILS, SET_CODE_CHANGED, SET_CONVERTING_PROJECT_ID, SET_CURRENT_CHAT_HISTORIES,
    SET_CURRENT_PROJECT_DETAILS,
    SET_IFRAME_URL, SET_IS_CHAT_IN_PROGRESS,
    SET_PROJECT_CODE,
    SET_TEMPORARY_FILE_CHANGES,
    UPDATE_PROJECT_DETAILS,
    UPDATED_PROJECT_CODE,
    SET_EDIT_MODE,
    SET_SELECTED_HTML_FILE,
    SET_DETECTED_ROUTES,
    SET_CONVERSATION_SUMMARY_PROMPT,
    SET_ELEVENLABS_CONNECTION_STATUS,
    SET_ELEVENLABS_SESSION_ID,
    SET_PM_AGENT_DIALOG_OPEN,
    SET_PM_AGENT_MESSAGES,
    SET_PM_CONVERSATION_SUCCESSFUL,
    SET_CURRENT_PM_SESSION_ID,
    SET_CONVERSATION_STEP,
    ConversationStep,
    ADD_NETWORK_ERROR,
    CLEAR_NETWORK_ERRORS,
    NetworkError
} from "../actions/projectdata.action.ts";
import { Misc } from "@/constants";

export interface IProjectCodeState {
    currentProjectDetails: any;
    currentChatHistories: any;
    code: string | null;
    tempCode: string | null;
    iframeUrl:string;
    codeChanged: boolean;
    isChatInProgress: boolean;
    convertingProjectId:string;
    isEditMode: boolean;
    selectedHtmlFile: string;
    detectedRoutes: any;
    conversationSummaryPrompt: string | null;
    elevenLabsConnectionStatus: 'idle' | 'connecting' | 'connected' | 'disconnected' | 'error';
    elevenLabsSessionId: string | null;
    pmAgentDialogOpen: boolean;
    pmAgentMessages: any[];
    pmConversationSuccessful: boolean;
    currentPmSessionId: string | null;
    conversationStep: ConversationStep;
    networkErrors: NetworkError[];
}

const INITIAL_STATE: IProjectCodeState = {
    currentProjectDetails: null,
    currentChatHistories: null,
    code: null,
    tempCode: null,
    iframeUrl: '',
    codeChanged: false,
    isChatInProgress: false,
    convertingProjectId:'',
    isEditMode: false,
    selectedHtmlFile: 'index.html',
    detectedRoutes: null,
    conversationSummaryPrompt: null,
    elevenLabsConnectionStatus: 'idle',
    elevenLabsSessionId: null,
    pmAgentDialogOpen: false,
    pmAgentMessages: [],
    pmConversationSuccessful: false,
    currentPmSessionId: null,
    conversationStep: 'requirement-gathering',
    networkErrors: []
};

export const projectDataReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case SET_CURRENT_PROJECT_DETAILS:
            return { ...state, currentProjectDetails: action.payload };

        case GET_CURRENT_PROJECT_DETAILS:
            return { ...state, currentProjectDetails: state.currentProjectDetails };

        case SET_PROJECT_CODE:
            return { ...state, code: action.payload, tempCode: action.payload };
        case UPDATE_PROJECT_DETAILS:
            return {
                ...state,currentProjectDetails: {
                    ...state.currentProjectDetails,
                    ...action.payload
                }
            }
        case GET_PROJECT_CODE:
            return { ...state, code: state.code };
        case UPDATED_PROJECT_CODE:
        case SET_TEMPORARY_FILE_CHANGES: {
            let temp_code = "{}"
            if (state.code) {
                temp_code = state.code
            }
            try {
                const updatedCode = {...JSON.parse(temp_code), ...JSON.parse(action.payload)};
                return action.type === UPDATED_PROJECT_CODE
                    ? {...state, code: JSON.stringify(updatedCode), tempCode: action.payload}
                    : {...state, tempCode: JSON.stringify(updatedCode)};
            } catch (error) {
                console.error("Error parsing JSON:", error);
                return state;
            }
        }
        case SET_IFRAME_URL:
            console.log('SET_IFRAME_URL', action.payload);
            
            return { ...state,iframeUrl: action.payload ,currentProjectDetails: {
                ...state.currentProjectDetails,
                preview_url: action.payload
            }}
        case RESET_PROJECT_DETAILS:
            localStorage.removeItem(Misc.LOCAL_STORAGE_CLAUDE_SESSION_ID);
            localStorage.removeItem(Misc.LOCAL_STORAGE_ADVANCED_MODE_PREFIX + state.currentProjectDetails?.id);
            return {
                ...state, ...INITIAL_STATE
            }
        case SET_CODE_CHANGED:
            return {...state, codeChanged: action.payload}
        case SET_IS_CHAT_IN_PROGRESS:
            return {...state, isChatInProgress: action.payload}
        case SET_CURRENT_CHAT_HISTORIES:
            return {...state, currentChatHistories: action.payload}

        case SET_CONVERTING_PROJECT_ID:
            return {...state, convertingProjectId: action.payload}

        case SET_EDIT_MODE:
            return {...state, isEditMode: action.payload}
        case SET_SELECTED_HTML_FILE:
            return {...state, selectedHtmlFile: action.payload}
        case SET_DETECTED_ROUTES:
            return {...state, detectedRoutes: action.payload}
        case SET_CONVERSATION_SUMMARY_PROMPT:
            return {...state, conversationSummaryPrompt: action.payload}

        case SET_ELEVENLABS_CONNECTION_STATUS:
            return {...state, elevenLabsConnectionStatus: action.payload}

        case SET_ELEVENLABS_SESSION_ID:
            return {...state, elevenLabsSessionId: action.payload}

        case SET_PM_AGENT_DIALOG_OPEN:
            return {...state, pmAgentDialogOpen: action.payload}

        case SET_PM_AGENT_MESSAGES:
            return {...state, pmAgentMessages: action.payload}

        case SET_PM_CONVERSATION_SUCCESSFUL:
            return {...state, pmConversationSuccessful: action.payload}

        case SET_CURRENT_PM_SESSION_ID:
            return {...state, currentPmSessionId: action.payload}

        case SET_CONVERSATION_STEP:
            return {...state, conversationStep: action.payload}

        case ADD_NETWORK_ERROR: {
            const updatedErrors = [...state.networkErrors, action.payload];
            // Keep only the latest 10 network errors
            const latestErrors = updatedErrors.slice(-10);
            return {
                ...state,
                networkErrors: latestErrors
            }
        }

        case CLEAR_NETWORK_ERRORS:
            return {
                ...state,
                networkErrors: []
            }

        default:
            return state;
    }
};
